module.exports = __webpack_public_path__ + "img/emoji_59.853225e4.png";